import * as signalR from '@microsoft/signalr';
import { AccessGuids, ConfigSystemParams, ErrorStrings, FieldAliases, FlatpickrFormat, msSize } from 'src/app/core/consts';
import { ActivatedRoute } from '@angular/router';
import { ActivityHeatmapComponent } from '../../_time-line/timeline-activity-heatmap/timeline-activity-heatmap.component';
import { AfterContentInit, AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, Observable, Subscription, throwError } from 'rxjs';
import { ChartConfigService } from 'src/app/core/services/utelize/general/chart-config-service';
import { ChartTodaysUsageComponent } from 'src/app/shared/widget-no-formsmodalmodule/chart-todays-usage/chart-todays-usage.component';
import { ChartUsagePerDayComponent } from 'src/app/shared/widget-no-formsmodalmodule/chart-usage-per-day/chart-usage-per-day.component';
import { CompaniesService } from 'src/app/core/services/utelize/system/company/companies-service';
import { CompanyDTO } from 'src/app/core/models/system/company/company.dto';
import { CompanyModalFormComponent } from '../../_company/company-modal-form/company-modal-form.component';
import { CompletedModalFormComponent } from 'src/app/forms-modal/_pop-ups/completed-modal-form/completed-modal-form.component';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DatePipe } from '@angular/common';
import { DecryptAesClientSide } from 'src/app/core/encryption';
import { DeviceDTO } from 'src/app/core/models/system/device/device.dto';
import { DevicesService } from 'src/app/core/services/utelize/system/device/devices-service';
import { DropdownDeviceComponent } from 'src/app/core/dropdowns/device/dropdown-device.component';
import { DropdownUserComponent } from 'src/app/core/dropdowns/user/dropdown-user.component';
import { EsimLocationDTO } from 'src/app/core/models/system/webbing/esim-location.dto';
import { eUser } from 'src/app/core/enums';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { formatDate } from 'devextreme/localization';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { LicencesCompanyAllocatedService } from 'src/app/core/services/utelize/system/licence/licences-company-allocated-service';
import { ManageEsimModalFormComponent } from '../../_manage-sim/manage-esim-modal-form/manage-esim-modal-form.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { OrderDTO } from 'src/app/core/models/system/order/order.dto';
import { OrdersService } from 'src/app/core/services/utelize/system/order/orders-service';
import { OurDate } from 'src/app/core/interfaces/general/our-date';
import { populateOurDate } from 'src/app/core/functions-generic/functions-generic-date';
import { ProductsService } from 'src/app/core/services/utelize/system/product/products-service';
import { RiskIntelligenceAccessService } from 'src/app/core/services/utelize/access/risk-intelligence/risk-intelligence-access.service';
import { SimStatusDisplay, SimStatusDisplay_EmptyObject } from 'src/app/core/interfaces/general/sim-status-display';
import { SimStatusService } from 'src/app/core/services/utelize/general/sim-status-service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TypesDeviceService } from 'src/app/core/services/utelize/system/type/types-device-service';
import { UserDTO } from 'src/app/core/models/system/user/user.dto';
import { UserModalFormComponent } from '../../_user/user-modal-form/user-modal-form.component';
import { UsersService } from 'src/app/core/services/utelize/system/user/users-service';
import { WarningModalFormComponent } from 'src/app/forms-modal/_pop-ups/warning-modal-form/warning-modal-form.component';
import { WebbingLiveDataDTO } from 'src/app/core/models/system/webbing/live-data.dto';
import { WebbingService } from 'src/app/core/services/utelize/system/webbing/webbing-service';
import { WidgetApplicationDetailsDTO } from 'src/app/core/models/system/widget/widget-application-details.dto';
import { WidgetCountryDetailsDTO } from 'src/app/core/models/system/widget/widget-country-details.dto';
import { WidgetCountryUsageSummaryDTO } from 'src/app/core/models/system/widget/widget-country-usage-summary.dto';
import { WidgetIccidTodayUsageDTO } from 'src/app/core/models/system/widget/widget-Iccid-today-usage.dto';
import { WidgetLiveTimeLineDTO } from 'src/app/core/models/system/widget/widget-live-timeline.dto';
import { WidgetService } from 'src/app/core/services/utelize/general/widget-service';

@Component({
  selector: 'app-timeline-esim-modal-form',
  templateUrl: './timeline-esim-modal-form.component.html',
  styleUrls: ['./timeline-esim-modal-form.component.scss']
})

export class TimelineEsimModalFormComponent implements AfterContentInit, AfterViewInit, OnDestroy, OnInit {

  @Input() disableManageSimForm  : boolean | undefined;
  @Input() embeddedFormMode      : boolean | undefined;
  @Input() initialInviewCompanyId: number  | undefined;
  
  @Output() riskButtonClick             : EventEmitter<{ lastCountry: string; companyID: number; }>=new EventEmitter<{ lastCountry: string; companyID: number; }>();
  @Output() timelineFormHasBeenCancelled: EventEmitter<void                                       >=new EventEmitter<void                                       >();
  
  @ViewChild('activityHeatmap',              { static: false }) activityHeatmap!             : ActivityHeatmapComponent;
  @ViewChild('chartTodaysUsage',             { static: false }) chartTodaysUsage!            : ChartTodaysUsageComponent;
  @ViewChild('chartUsagePerDay',             { static: false }) chartUsagePerDay!            : ChartUsagePerDayComponent;
  @ViewChild('companyModalForm',             { static: false }) companyModalForm!            : CompanyModalFormComponent;
  @ViewChild('completedModalForm',           { static: false }) completedModalForm!          : CompletedModalFormComponent;
  @ViewChild('countryUsageContainer')                           countryUsageContainer!       : ElementRef;
  @ViewChild('deviceSelector',               { static: false }) deviceSelector!              : DropdownDeviceComponent;
  @ViewChild('manageEsimModalForm',          { static: false }) manageEsimModalForm!         : ManageEsimModalFormComponent;
  @ViewChild('timelineEsimModalFormContent', { static: false }) timelineEsimModalFormContent!: TemplateRef<void>;
  @ViewChild('userModalForm',                { static: false }) userModalForm!               : UserModalFormComponent;
  @ViewChild('userSelector',                 { static: false }) userSelector!                : DropdownUserComponent;
  @ViewChild('warningModalForm',             { static: false }) warningModalForm!            : WarningModalFormComponent;

  get fieldAliasUsername() { return this.configSystemService.getValue(ConfigSystemParams.FieldAliasUsername, FieldAliases.FieldAliasUsername); }
  get modalBackGround   () { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE"       );
                             return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false)              }

  //CRN_20250814 - sizeDefaultCountryDay & sizeDefaultCountrySummary rough & ready, Matt A wants live with showApplicationChart only available for Utelize at the moment
  get showExpansionLinks          () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormTimelineLinksExpansionShow,              true  ) &&
                                              this.showApplicationContainer                                                                                     ; }
  get showApplicationContainer    () { return this.featureEnabledApplicationGraph                                                                               ; }
  get showApplicationChart        () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormTimelineApplicationSummaryShowChart,     false ); }
  get showApplicationLegend       () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormTimelineApplicationSummaryShowLegend,    false ); }
  get suppressOriginalWebbingError() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.WebbingSuppressOriginalError,                true  ); }
  get sureSimContainerGrow        () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SureSimContainerGrow,                        false ) &&
                                              !this.componentAccessUserService.hasAccessGuid(AccessGuids.AnimationSureSimContainerGrowGuard,             true  ); }
  get showRiskButton              () { return this.riskIntelligenceAccessService.canShow() && !!(this.sureSimOrder?.orderSpendDTO?.lastCountry ?? ''           ); }
  get timelineDisplayVersion2     () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TimelineDisplayVersion2,                     false ); }
  get todaysUsageGraphInMbOnly    () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormTimelineTodaysUsageGraphInMbOnly,        false ); }

  get sessionThresholdMB       () { return     this.configSystemService.getValueAsInteger(ConfigSystemParams.FormTimelineSessionThresholdMB,             0   ); }
  get sizeDefaultApplication   () { return     this.configSystemService.getValueAsInteger(ConfigSystemParams.FormTimelineApplicationSummaryMaxHeight,    163 ); }
  get sizeDefaultCountryDay    () { let height=this.configSystemService.getValueAsInteger(ConfigSystemParams.FormTimelineCountryUsageAndDetailMaxHeight, 168 );
                                        height=this.showApplicationContainer ? height : height+273;
                                    return     height                                                                                                         ; }
  get sizeDefaultCountrySummary() { let height=this.configSystemService.getValueAsInteger(ConfigSystemParams.FormTimelineCountryUsageSummaryMaxHeight,   168 );
                                        height=this.showApplicationContainer ? height : 150;
                                    return     height                                                                                                         ; }
  
  private companyIdData!                : CompanyDTO[];
  private companyModalFormIsOpen        : boolean=false;
  private deviceTypeIdData!             : IdAndDescriptionDTO[];
  private enableFeaturesHasExecuted     : boolean=false;
  private featureEnabledApplicationGraph: boolean=false;
  // private hubConnection                : signalR.HubConnection;
  private manageEsimFormIsOpen          : boolean=false;
  private maxValue                      : number=0;
  private monthSessionsTotal            : number | undefined;
  private productIdData!                : IdAndDescriptionDTO[];
  private selectedCompany?              : CompanyDTO;
  private selectedUser?                 : IdAndDescriptionDTO;
  private subApplications               : string[]=[];
  private subApplicationUsageDayOfMonth : string[]=[];
  private subApplicationUsageSummary!   : Subscription | undefined;
  private subApplictionSeries           : {name: string, data: number[]}[] = [];
  private subCountryDetails!            : Subscription | undefined;
  private subCountryUsageSummary!       : Subscription | undefined;
  private subIccidTodayUsage!           : Subscription | undefined;
  private subLiveDataByIccid!           : Subscription | undefined;
  private subLocationDataByIccid!       : Subscription | undefined;
  private subOrderWithSpend!            : Subscription | undefined;
  private subSimActivity!               : Subscription | undefined;
  private subTimeline!                  : Subscription | undefined;
  private sureSimOrder                  : OrderDTO | undefined;
  private sureSimOrderGetDataOnly       : boolean=false;
  private sureSimOrderId                : number | undefined;
  private sureSimUser                   : UserDTO | undefined;
  private timelineEsimModalFormRef!     : NgbModalRef;
  private todaySessionsTotal            : number | undefined;
  private todayUsageTotal               : number | undefined;
  private todayUsageTotalWithSymbol     : string | undefined;
  private userIdData!                   : IdAndDescriptionDTO[];
  private userModalFormIsOpen           : boolean=false;

  public applicationChartUsage         : any | undefined;
  public applicationData               : WidgetApplicationDetailsDTO[] | undefined;
  public applicationUsageSummary       : WidgetApplicationDetailsDTO[] | undefined;
  public applicationUsageSummaryGrid   : WidgetApplicationDetailsDTO[] | undefined;
  public breadCrumbItems!              : Array<{}>;
  public containerHeightApplication    : number=0;
  public containerHeightCountryDetails : number=0;
  public containerHeightCountryUsage   : number=0;
  public countryDetails                : WidgetCountryDetailsDTO[] | undefined;
  public countryUsageSummary           : WidgetCountryUsageSummaryDTO[] | undefined;
  public currProduct                   : IdAndDescriptionDTO | undefined;
  public curUser                       : SystemUserDTO;
  public curUserCompanyID              : number;
  public curUserID                     : number | undefined;
  public dataLoaded                    : boolean=false;
  public enableMangeSimForm            : boolean=false;
  public expandApplicationUsage        : boolean=false;
  public expandCountryDay              : boolean=false;
  public expandCountrySummary          : boolean=false;
  public expandDeviceDetails           : boolean=true;
  public expandOrderDetails            : boolean=false;
  public expandSimDetails              : boolean=false;
  public filterCompanyID               : number | undefined;
  public filterDate                    : OurDate | undefined=populateOurDate(this.exceptionsService, Date.now());
  public filterDateFormat              : string=FlatpickrFormat.MonthWordFull_Year;
  public filterDeviceID                : number | undefined;
  public filterUserID                  : number | undefined; 
  public formSubmitted                 : boolean=false;
  public formTitle                     : string | undefined;
  public gotIccid                      : boolean=false;
  public liveTimeLineData              : WidgetLiveTimeLineDTO[] | undefined;
  public locationDataLoaded            : boolean=false;
  public modalPassedIccid              : null | string | undefined;
  public routePassedIccid              : null | string | undefined;
  public selectedIccid                 : string | undefined;
  public showFilters                   : boolean=true;
  public simActivityVisible            : boolean=true;
  public sizeColapsedApplication       : number=0;
  public sizeColapsedCountryDay        : number=0;
  public sizeColapsedCountrySummary    : number=0;
  public sizeExpandedApplication       : number=440;
  public sizeExpandedCountryDay        : number=441;
  public sizeExpandedCountrySummary    : number=441;
  public sureSimDevice                 : DeviceDTO | undefined;
  public sureSimLiveData               : WebbingLiveDataDTO | undefined;
  public sureSimLocationData           : EsimLocationDTO | undefined;
  public timelineForm!                 : UntypedFormGroup;
  public todayUsageTotalSymbol         : string | undefined;
  public useFullPage                   : boolean=true;

  //#region for Validators
  
  public customerTagMaxLength    : number=50;
  public emailMaxLength          : number=100;
  public msisdnMaxLength         : number=25;
  public mobileNumberMaxLength   : number=100;
  public orderNoMaxLength        : number=50;
  public supplierOrderNoMaxLength: number=32;

  //#endregion
  
  constructor(
    private activatedRoute                 : ActivatedRoute,
    private authenticationService          : AuthenticationService,
    private chartConfigService             : ChartConfigService,
    private companiesService               : CompaniesService,
    private componentAccessUserService     : ComponentAccessUserService,
    private configSystemService            : ConfigSystemService,
    private datePipe                       : DatePipe,
    private devicesService                 : DevicesService,
    private exceptionsService              : ExceptionsService,
    private formBuilder                    : UntypedFormBuilder,
    private lastPassKillerService          : LastPassKillerService,
    private licencesCompanyAllocatedService: LicencesCompanyAllocatedService,
    private modalService                   : NgbModal,
    private ordersService                  : OrdersService,
    private productsService                : ProductsService,
    private riskIntelligenceAccessService  : RiskIntelligenceAccessService,
    private simStatusService               : SimStatusService,
    private typesDeviceService             : TypesDeviceService,
    private usersService                   : UsersService,
    private webbingService                 : WebbingService,
    private widgetService                  : WidgetService
  ) {
    this.curUser         =this.authenticationService.currentUserObject();
    this.curUserCompanyID=this.curUser.companyId;
    this.filterCompanyID =this.curUserCompanyID;

    // this.hubConnection    =new signalR.HubConnectionBuilder()
    //                            .withUrl(environment.eSimApiWithoutApiPath + eSimApiPaths.WidgetsLiveTimelineHub,
    //                                     { withCredentials: true,
    //                                       transport      : signalR.HttpTransportType.LongPolling |
    //                                                        signalR.HttpTransportType.ServerSentEvents |
    //                                                        signalR.HttpTransportType.WebSockets,
    //                                       headers        : {
    //                                         Authorization                         : `Bearer ${DecryptAesClientSide(this.storageService.getItem(StorageValues.encToken))}`,
    //                                         [environment.webbingConfig.apiKeyName]: environment.webbingConfig.apiKeyValue
    //                                       }})
    //                            .configureLogging(signalR.LogLevel.Debug)
    //                            .build();
  }

  public ngOnInit(): void {
    try {
      this.enableMangeSimForm=!this.disableManageSimForm;
      this.routePassedIccid  =this.activatedRoute.snapshot.paramMap.get("iccid");

      if (this.routePassedIccid)
        this.routePassedIccid=DecryptAesClientSide(this.routePassedIccid);
      // this.hubConnection
      // .start()
      // .then(() => {
      //   console.log('Connected to SignalR hub');
      // })
      // .catch(error => {
      //   this.timelineFormHasBeenCancelled.emit();
      //   this.exceptionsService.handleException(new Error(error));
      // });

      // this.hubConnection.on('ReceiveLiveTimelineUpdate', (liveTimelineData) => {
      //   this.liveTimeLineData=liveTimelineData;
      // });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
      this.resetMainVariables();

      if (this.embeddedFormMode) {
        this.showFilters=this.routePassedIccid ? false : true;
        this.resetForm();

        if (this.routePassedIccid) {
          this.selectedIccid=this.routePassedIccid;
          this.getData();
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterContentInit(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy() {
    try {
      // this.hubConnection.stop().catch(error => {
      //   this.exceptionsService.handleException(new Error(error));
      // });

      this.lastPassKillerService.stop();
      this.unsubscribeAllConnections();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public unsubscribeAllConnections(): void {
    try {
      this.unsubscribeApplicationUsageSummary();
      this.unsubscribeCountryDetails();
      this.unsubscribeCountryUsageSummary();
      this.unsubscribeIccidTodayUsage();
      this.chartTodaysUsage?.unsubscribeIccidTodayUsage();
      this.chartUsagePerDay?.unsubscribeIccidTotalUsage();
      this.unsubscribeLiveDataByIccid();
      this.unsubscribeOrderWithSpend();
      this.unsubscribeSimActivity();
      this.unsubscribeTimeline();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public closeForm(): void {
    try {
      this.unsubscribeAllConnections();
      this.timelineEsimModalFormRef.close();
      this.timelineFormHasBeenCancelled.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openRiskTripReady(): void {
    try {
      this.riskButtonClick.emit({
        companyID  : this.sureSimOrder?.companyID                  ?? 0,
        lastCountry: this.sureSimOrder?.orderSpendDTO?.lastCountry ?? ''
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public resetMainVariables(): void {
    try {
      this.applicationChartUsage         =undefined;
      this.applicationUsageSummary       =[];
      this.applicationUsageSummaryGrid   =[];
      this.companyModalFormIsOpen        =false;
      this.containerHeightApplication    = this.sizeColapsedApplication;
      this.containerHeightCountryDetails = this.sizeColapsedCountryDay;
      this.containerHeightCountryUsage   = this.sizeColapsedCountrySummary;
      this.countryDetails                =[];
      this.countryUsageSummary           =[];
      this.currProduct                   =undefined;
      this.dataLoaded                    =false;
      this.enableFeaturesHasExecuted     =false;
      this.expandApplicationUsage        =false;
      this.expandCountryDay              =false;
      this.expandCountrySummary          =false;
      this.expandDeviceDetails           =true;
      this.expandOrderDetails            =false;
      this.expandSimDetails              =false;
      this.featureEnabledApplicationGraph=false;
      this.filterDeviceID                =undefined;
      this.formSubmitted                 =false;
      this.formTitle                     ="Live View";
      this.gotIccid                      =false;
      this.liveTimeLineData              =[];
      this.locationDataLoaded            =false;
      this.monthSessionsTotal            =undefined;
      this.selectedIccid                 =undefined;
      this.simActivityVisible            =!this.timelineDisplayVersion2;
      this.sureSimDevice                 =undefined;
      this.sureSimLiveData               =undefined;
      this.sureSimLocationData           =undefined;
      this.sureSimOrder                  =undefined;
      this.sureSimOrderGetDataOnly       =false;
      this.sureSimOrderId                =undefined;
      this.sureSimUser                   =undefined;
      this.todaySessionsTotal            =undefined;
      this.todayUsageTotal               =undefined;
      this.todayUsageTotalSymbol         =undefined;
      this.todayUsageTotalWithSymbol     =undefined;
      this.enableFeatures();
      this.populateFormFields(this.timelineForm, false, true);
      this.activityHeatmap?.refreshHeatMap(undefined);
      this.unsubscribeApplicationUsageSummary();
      this.unsubscribeCountryDetails();
      this.unsubscribeCountryUsageSummary();
      this.unsubscribeIccidTodayUsage();
      this.chartTodaysUsage?.unsubscribeIccidTodayUsage();
      this.chartUsagePerDay?.unsubscribeIccidTotalUsage();
      this.unsubscribeLiveDataByIccid();
      this.unsubscribeOrderWithSpend();
      this.unsubscribeSimActivity();
      this.unsubscribeTimeline();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public resetForm(): void {
    try {
      this.resetMainVariables();
      this.refreshCompanyData();
      this.refreshDeviceTypeData();
      this.refreshProductData();
      this.setUpForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public openForm(iccid: string | undefined): void {
    try {
      this.expandDeviceDetails=true;
      this.expandOrderDetails =false;
      this.expandSimDetails   =false;

      if (iccid != undefined && iccid.trim() != "") {
        //CRN_20250814 - Accessed via ManageSIM modal.LiveView.tab
        this.modalPassedIccid=iccid;
        this.selectedIccid   =iccid;
        
        this.getData();
      }

      this.showFilters=!iccid;

      this.resetForm();
      this.openModal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private openModal(): void {
    try {
      this.timelineEsimModalFormRef=this.modalService.open(this.timelineEsimModalFormContent, { backdrop   : this.modalBackGround,
                                                                                                keyboard   : false,
                                                                                                scrollable : true,
                                                                                                size       : msSize.FullScreen,
                                                                                                windowClass: "modal-fullscreen" });

      this.timelineEsimModalFormRef.result.then(
        () => { },
        () => { this.unsubscribeAllConnections(); }
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public dateFilterChanged(selectedDate: OurDate) {
    try {
      this.filterDate=selectedDate;
      
      this.getData();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region timelineForm

  get formData() {
    return this.timelineForm.controls;
  }

  public getSimStatus(): SimStatusDisplay {
    try {
      return this.simStatusService.getDisplay(this.formData['status']?.value,
                                              this.formData['statusDisplay']?.value,
                                              this.formData['statusIcon']?.value);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return SimStatusDisplay_EmptyObject();
    }
  }

  public getSimStatusBgClass(): string {
    try {
      switch (this.getSimStatus().statusIcon) {
        case "SwitchedOn":
          return "custom-bg-success";
        case "Barred"   :
        case "Ceased"   :
        case "Suspended":
          return "custom-bg-danger";
        case "AlertProductChanged":
        case "AlertThrottled"     :
        case "Removed"            :
        case "SwitchedOff"        :
          return "custom-bg-warning";
        default:
          return "custom-bg-secondary";
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "custom-bg-secondary";
    }
  }

  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.removeFormFields(this.timelineForm);

      this.timelineForm=this.formBuilder.group({ });

      this.addFormFields(this.timelineForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.timelineForm) {
        this.addFormControl(formGroup, "companyId",                  "",               []);
        this.addFormControl(formGroup, "currentDaySessions",         "",               []);
        this.addFormControl(formGroup, "currentDayUsage",            "",               []);
        this.addFormControl(formGroup, "currentMonthCost",           "",               []);
        this.addFormControl(formGroup, "currentMonthSessions",       "",               []);
        this.addFormControl(formGroup, "currentMonthUsage",          "",               []);
        this.addFormControl(formGroup, "customerTag",                "",               []);
        this.addFormControl(formGroup, "deviceTypeId",               "",               []);
        this.addFormControl(formGroup, "email",                      "",               []);
        this.addFormControl(formGroup, "iccid",                      "",               []);
        this.addFormControl(formGroup, "msisdn",                     "",               []);
        this.addFormControl(formGroup, "eid",                        "",               []);
        this.addFormControl(formGroup, "filtersCheck",               this.showFilters, []);
        this.addFormControl(formGroup, "lastCountryFlagIcon",        "",               []);
        this.addFormControl(formGroup, "lastCountryUsage",           "",               []);
        this.addFormControl(formGroup, "lastLocation",               "",               []);
        this.addFormControl(formGroup, "lastLocationCountry",        "",               []);
        this.addFormControl(formGroup, "lastLocationCountryFlagIcon","",               []);
        this.addFormControl(formGroup, "lastLocationDate",           "",               []);
        this.addFormControl(formGroup, "lastUsageDate",              "",               []);
        this.addFormControl(formGroup, "liveApn",                    "",               []);
        this.addFormControl(formGroup, "liveImei",                   "",               []);
        this.addFormControl(formGroup, "liveIp",                     "",               []);
        this.addFormControl(formGroup, "liveModel",                  "",               []);
        this.addFormControl(formGroup, "livePdp",                    "",               []);
        this.addFormControl(formGroup, "liveVendor",                 "",               []);
        this.addFormControl(formGroup, "liveVplmn",                  "",               []);
        this.addFormControl(formGroup, "mobileNumber",               "",               []);
        this.addFormControl(formGroup, "orderNo",                    "",               []);
        this.addFormControl(formGroup, "productId",                  "",               []);
        this.addFormControl(formGroup, "status",                     "",               []);
        this.addFormControl(formGroup, "statusDisplay",              "",               []);
        this.addFormControl(formGroup, "statusIcon",                 "",               []);
        this.addFormControl(formGroup, "supplierOrderNo",            "",               []);
        this.addFormControl(formGroup, "userId",                     "",               []);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | string,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private mobileForDisplay(user: UserDTO | undefined): string | undefined {
    try {
      if (user==undefined)
        return undefined;

      if (this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserUseInternationalDialCode, false)
        && user.mobileE164 != null
        && user.mobileE164 != undefined
        && user.mobileE164.trim() != "")
        return user.mobileE164;

      return user.mobile;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return user?.mobile;
    }
  }

  private populateFormFields(formGroup: UntypedFormGroup, userDetailsOnly: boolean, clearfields: boolean) {
    try {
      if (formGroup != undefined && formGroup==this.timelineForm) {
        if (!userDetailsOnly) {
          
          if (clearfields || this.sureSimDevice != undefined) {
            this.timelineForm.controls["deviceTypeId"].setValue(clearfields ? undefined : this.sureSimDevice?.deviceTypeID);
            this.timelineForm.controls["iccid"].setValue(clearfields ? undefined : this.sureSimDevice?.imeiIccid);
            this.timelineForm.controls["msisdn"].setValue(clearfields ? undefined : this.sureSimDevice?.msisdn);
          }
                
          if (clearfields || this.sureSimLiveData != undefined) {
            this.timelineForm.controls["liveApn"].setValue(clearfields ? undefined : this.sureSimLiveData?.APN);
            this.timelineForm.controls["liveImei"].setValue(clearfields ? undefined : this.sureSimLiveData?.IMEI);
            this.timelineForm.controls["liveIp"].setValue(clearfields ? undefined : this.sureSimLiveData?.IP);
            this.timelineForm.controls["liveModel"].setValue(clearfields ? undefined : this.sureSimLiveData?.Model);
            this.timelineForm.controls["livePdp"].setValue(clearfields ? undefined : this.sureSimLiveData?.PDP);
            this.timelineForm.controls["liveVendor"].setValue(clearfields ? undefined : this.sureSimLiveData?.Vendor);
            this.timelineForm.controls["liveVplmn"].setValue(clearfields ? undefined : this.sureSimLiveData?.VPLMN);
          }

          if (clearfields || this.sureSimLocationData != undefined) {
            let lastLocationDate: Date | undefined | null=this.sureSimLocationData?.LastUpdate;

            this.timelineForm.controls["lastLocation"].setValue(clearfields ? undefined
                                                                            : this.sureSimLocationData?.Village != '' ? this.sureSimLocationData?.Village
                                                                                                                      : this.sureSimLocationData?.Town != '' ? this.sureSimLocationData?.Town
                                                                                                                                                             : this.sureSimLocationData?.City);
            this.timelineForm.controls["lastLocationCountry"].setValue(clearfields ? undefined : this.sureSimLocationData?.CountryName);
            this.timelineForm.controls["lastLocationCountryFlagIcon"].setValue(clearfields ? undefined : this.sureSimLocationData?.CountryFlagIcon);
            this.timelineForm.controls["lastLocationDate"].setValue(lastLocationDate ? this.datePipe.transform((new Date(lastLocationDate)), 'dd/MM/yyyy HH:mm') : undefined);
          }
                
          if (clearfields || this.sureSimOrder != undefined) {
            this.timelineForm.controls["companyId"].setValue(clearfields ? undefined : this.sureSimOrder?.companyID);
            this.timelineForm.controls["eid"].setValue(clearfields ? undefined : this.sureSimOrder?.eid);
            this.timelineForm.controls["orderNo"].setValue(clearfields ? undefined : this.sureSimOrder?.orderNo);
            this.timelineForm.controls["productId"].setValue(clearfields ? undefined : this.sureSimOrder?.productID);
            this.timelineForm.controls["status"].setValue(clearfields ? undefined : this.sureSimOrder?.status);
            this.timelineForm.controls["statusDisplay"].setValue(clearfields ? undefined : this.sureSimOrder?.statusDisplay); //RBW_20260820
            this.timelineForm.controls["statusIcon"].setValue(clearfields ? undefined : this.sureSimOrder?.statusIcon);       //RBW_20260820
            this.timelineForm.controls["supplierOrderNo"].setValue(clearfields ? undefined : this.sureSimOrder?.supplierOrderNo);
            this.timelineForm.controls["userId"].setValue(clearfields ? undefined : this.sureSimOrder?.userID);
            
            if (clearfields || this.sureSimOrder?.orderSpendDTO != undefined) {
              let lastUsageDate: Date | undefined | null=this.sureSimOrder?.orderSpendDTO.lastUsage;

              this.timelineForm.controls["currentMonthCost"].setValue(clearfields ? undefined : this.sureSimOrder?.orderSpendDTO.costWithCurrencySymbol);
              this.timelineForm.controls["currentMonthUsage"].setValue(clearfields ? undefined : this.sureSimOrder?.orderSpendDTO.usageWithMbOrGb);
              this.timelineForm.controls["lastCountryFlagIcon"].setValue(clearfields ? undefined : this.sureSimOrder?.orderSpendDTO.lastCountryFlagIcon);
              this.timelineForm.controls["lastCountryUsage"].setValue(clearfields ? undefined : this.sureSimOrder?.orderSpendDTO.lastCountry);
              this.timelineForm.controls["lastUsageDate"].setValue(lastUsageDate ? this.datePipe.transform((new Date(lastUsageDate)), 'dd/MM/yyyy HH:mm') : undefined);
            }
            
            if (clearfields || this.todayUsageTotalWithSymbol)
              this.timelineForm.controls["currentDayUsage"].setValue(clearfields ? undefined : this.todayUsageTotalWithSymbol);

            if (clearfields || this.todaySessionsTotal != undefined)
              this.timelineForm.controls["currentDaySessions"].setValue(clearfields ? undefined : this.todaySessionsTotal);

            if (clearfields || this.monthSessionsTotal != undefined)
              this.timelineForm.controls["currentMonthSessions"].setValue(clearfields ? undefined : this.monthSessionsTotal);
          }
        }
                
        if (clearfields || this.sureSimUser != undefined) {
          this.timelineForm.controls["email"].setValue(clearfields ? undefined : this.sureSimUser?.email);
          this.timelineForm.controls["mobileNumber"].setValue(clearfields ? undefined : this.mobileForDisplay(this.sureSimUser));
          this.timelineForm.controls["customerTag"].setValue(clearfields ? undefined : this.sureSimUser?.tag);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public saveFormData() {
    try {
      this.formSubmitted=true;
      
      if (this.timelineForm.valid) {

      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private enableDisableControls(enabled: boolean) {
    try {
      if (enabled) {

      } else {

      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion

  //#region Dropdown Arrays

  public getDropdownDataObjectArray(fieldName: string) {
    try {
      if (fieldName=="deviceTypeId") {
        return this.deviceTypeIdData;

      } else if (fieldName=="productId") {
        return this.productIdData;

      } else if (fieldName=="userId") {
        return this.userIdData;
      }

      return undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  public getDropdownDataObjectArray_Company() {
    try {
      return this.companyIdData;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  private getDropdownData(dataSource: Observable<any>, fieldName: string) {
    try {
      if (dataSource) {
        dataSource
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (fieldName=="companyId") {
              this.companyIdData=(data as CompanyDTO[]);
              
              this.companySelectDropDownChange(undefined);
            
            } else if (fieldName=="deviceTypeId") {
              this.deviceTypeIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="productId") {
              this.productIdData=(data as IdAndDescriptionDTO[]);
              
            } else if (fieldName=="userId") {
              this.userIdData=(data as IdAndDescriptionDTO[]);
              
              this.userSelectDropDownChange(undefined);
              
            }
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Refresh Dropdown Arrays Data

  public refreshCompanyData() {
    try {
      this.getDropdownData(this.companiesService.getForLoggedInUser(this.curUser.userId), "companyId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshDeviceTypeData() {
    try {
      this.getDropdownData(this.typesDeviceService.getIdAndDescription(), "deviceTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshProductData() {
    try {
      this.getDropdownData(this.productsService.getIdAndDescription(this.curUser.userId), "productId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshUserData() {
    try {
      let companyId: number=this.timelineForm.get('companyId')?.value;
      
      this.getDropdownData(this.usersService.getIdAndFullNameByCompanyId(companyId), "userId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Company

  public companyFilterOnChange(companyID: number) {
    try {
      this.resetMainVariables();

      this.filterCompanyID=companyID==null      || 
                           companyID==undefined ||
                           companyID<=0
                           ?
                           0 - this.curUserCompanyID
                           :
                           companyID;

      if (this.deviceSelector && this.userSelector) {
        this.filterDeviceID=-1;
        this.filterUserID  =-1;

        if (this.filterCompanyID<0) {
          this.deviceSelector.companyId                  =0 - this.filterCompanyID;
          this.deviceSelector.showCompanySureSimDevices  =false;
          this.deviceSelector.showHierarchySureSimDevices=true;
          this.userSelector.companyId                    =0 - this.filterCompanyID;
          this.userSelector.showCompanySureSimDevices    =false;
          this.userSelector.showHierarchySureSimDevices  =true;
        } else {
          this.deviceSelector.companyId                  =this.filterCompanyID;
          this.deviceSelector.showCompanySureSimDevices  =true;
          this.deviceSelector.showHierarchySureSimDevices=false;
          this.userSelector.companyId                    =this.filterCompanyID;
          this.userSelector.showCompanySureSimDevices    =true;
          this.userSelector.showHierarchySureSimDevices  =false;
        }

        this.deviceSelector.clearSelection();
        this.userSelector.clearSelection();
        this.userSelector.refreshData();
        this.deviceSelector.refreshData();
        this.getData();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public companySelectDropDownChange(ev: any) {
    try {
      if (this.companyIdData==undefined)
        return;

      this.enableDisableControls(false);
      
      this.selectedCompany=this.companyIdData.find(x => x.id==this.timelineForm.get('companyId')?.value);
      let gotCompany      =this.selectedCompany?.id != undefined && <number>this.selectedCompany?.id>0;      
  
      if (gotCompany) {
        this.refreshUserData();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public viewCompany() {
    try {
      let companyId: number=this.timelineForm.get('companyId')?.value;

      if (!this.companyModalFormIsOpen) {
        this.companyModalFormIsOpen=true;

        this.companyModalForm.openForm(companyId);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public companyDataHasBeenSaved(sureSimCompanyId: number | undefined) {
    try {
      this.companyModalFormIsOpen=false;

      if (sureSimCompanyId != undefined && <number>sureSimCompanyId>0) {
        this.refreshCompanyData();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public companyFormHasBeenCancelled() {
    try {
      this.companyModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region User

  public userFilterOnChange(userID: number) {
    try {
      this.resetMainVariables();
      
      if (userID==-1) {
        this.filterUserID=undefined;
      } else {
        this.filterUserID=userID;
      }

      if (this.deviceSelector && this.userSelector) {
        this.filterDeviceID=-1;
        this.deviceSelector.clearSelection();
        this.deviceSelector.userId=this.filterUserID;
        this.deviceSelector.refreshData();
        this.getData();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public userSelectDropDownChange(ev: any) {
    try {
      if (this.userIdData==undefined)
        return;

      this.enableDisableControls(false);
      
      this.selectedUser=this.userIdData.find(x => x.id==this.timelineForm.get('userId')?.value);
      let gotUser      =this.selectedUser?.id != undefined && <number>this.selectedUser?.id>0;      
  
      if (gotUser) {
        
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public viewUser() {
    try {
      let userId: number=this.timelineForm.get('userId')?.value;
      
      if (!this.userModalFormIsOpen) {
        this.userModalFormIsOpen=true;
      
        this.userModalForm.openForm(userId, eUser.sim);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public sureSimUserHasBeenSaved(sureSimUserId: number | undefined) {
    try {
      this.userModalFormIsOpen=false;

      if (sureSimUserId != undefined && <number>sureSimUserId>0) {
        this.getSureSimOrder(true);
        this.getSureSimUser(true);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public userFormHasBeenCancelled() {
    try {
      this.userModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Device
  
  public deviceFilterOnChange(deviceID: number) {
    try {
      this.resetMainVariables();
      
      if (deviceID==-1) {
        this.filterDeviceID=undefined;
      } else {
        this.filterDeviceID=deviceID;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public deviceFilterOnChangeIccid(iccid: string | undefined) {
    try {
      this.selectedIccid=(iccid != undefined && iccid .trim()=="") ? undefined : iccid;

      this.getData();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public viewDevice() {
    try {
      if (!this.manageEsimFormIsOpen) {
        this.manageEsimFormIsOpen=true;
        this.manageEsimModalForm.openForm(<number>this.sureSimOrderId);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Data
  
  public getData() {
    try {
      this.getSureSimOrderId();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region SureSIM Order

  public getSureSimOrderId() {
    try {
      if (this.selectedIccid==undefined)
        return;

      this.ordersService.getOrderIdByIccid(this.selectedIccid)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.sureSimOrderId=data["result"];

          this.getSureSimOrder(false);
         },
        error: error => {
          this.timelineFormHasBeenCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public getSureSimOrder(refreshUserDetailsOnly: boolean) {
    try {
      this.unsubscribeOrderWithSpend();

      if (this.sureSimOrderId==undefined)
        return;
                 
      this.subOrderWithSpend=this.ordersService.getOrderWithSpendUpdates(this.sureSimOrderId)
                             .pipe(
                               catchError((error) => {
                                 return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
                               })
                             )
                             .subscribe({
                               next: data => {
                                 this.sureSimOrder=data;
                                 this.currProduct =this.productIdData.find(x => x.id==(this.sureSimOrder!.productID ?? -1));

                                 //#region format usageWithMbOrGb

                                 if (this.sureSimOrder.orderSpendDTO && this.sureSimOrder.orderSpendDTO.usageWithMbOrGb) {
                                   this.sureSimOrder.orderSpendDTO.usageWithMbOrGb=this.sureSimOrder.orderSpendDTO.usageWithMbOrGb.replace(" ", "");
                                   const rawValue                                 =this.sureSimOrder.orderSpendDTO.usageWithMbOrGb;
                                   const match                                    =rawValue.match(/^([\d.]+)([a-zA-Z]+)$/);

                                   if (match) {const
                                     number                                         =parseFloat(match[1]);
                                     const unit                                     =match[2];
                                     this.sureSimOrder.orderSpendDTO.usageWithMbOrGb=number.toFixed(1) + unit;
                                    }
                                 }

                                 //#endregion

                                 this.populateFormFields(this.timelineForm, false, false);
                                        
                                 if (!this.sureSimOrderGetDataOnly) {

                                   if (this.routePassedIccid || this.modalPassedIccid) {
                                     this.filterDeviceID=this.sureSimOrder.deviceID;
                                   }

                                   if (refreshUserDetailsOnly) {
                                     this.getDropdownData(this.usersService.getIdAndFullNameByCompanyId(<number>this.sureSimOrder.companyID), "userId");
                                   
                                   } else {
                                     this.getSureSimDevice();
                                     this.getSureSimUser(false);
                                     this.companySelectDropDownChange(undefined);
                                   }
                                        
                                   this.sureSimOrderGetDataOnly=true;
                                 }
                               },
                               error: error => {
                                 this.timelineFormHasBeenCancelled.emit();
                                 this.exceptionsService.handleException(new Error(error));
                               }
                             });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
      
  public unsubscribeOrderWithSpend() {
    try {
      if (this.subOrderWithSpend) {
        this.subOrderWithSpend.unsubscribe();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
      
  public getSureSimDevice() {
    try {
      let deviceID=this.sureSimOrder?.deviceID==undefined ? -1 : this.sureSimOrder?.deviceID;
                   
      this.devicesService.getById(<number>deviceID)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.sureSimDevice=data;
          this.gotIccid     =this.sureSimDevice.imeiIccid != undefined && this.sureSimDevice.imeiIccid.trim() != "";
          this.formTitle   += " - " + this.sureSimDevice.imeiIccid;
          
          this.setRightSideContainerHeights();
          this.populateFormFields(this.timelineForm, false, false);
          this.getApplicationTotalUsage();
          this.getCountryDetails();
          this.getCountryUsageSummary();
          this.getIccidTodayUsage();
          //👆 this.chartTodaysUsage?.getIccidTodayUsage(this.sureSimDevice?.imeiIccid); //CRN_20261013 - getIccidTodayUsage() feeds chart via addReading()
          this.chartTodaysUsage?.resetReadings();
          this.chartUsagePerDay?.getIccidTotalUsage(this.sureSimDevice?.imeiIccid);
          this.getLiveTimeline();
          this.getLiveData();
          this.getLocationData();
          this.getSimActivity();
         },
        error: error => {
          this.timelineFormHasBeenCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
      
  public getSureSimUser(refreshUserDetailsOnly: boolean) {
    try {
      let userID=this.sureSimOrder?.userID==undefined ? -1 : this.sureSimOrder?.userID;
               
      if (userID==undefined || userID<=0)
        return;
               
      this.usersService.getById(<number>userID)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.sureSimUser=data;
          this.populateFormFields(this.timelineForm, true, refreshUserDetailsOnly);
          this.getCountryDetails();
          this.getCountryUsageSummary();
          this.getLiveTimeline();
         },
        error: error => {
          this.timelineFormHasBeenCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#region Live Data

  public getLiveData() {
    try {
      this.unsubscribeLiveDataByIccid();

      let imeiIccid=this.sureSimDevice?.imeiIccid==undefined ? -1 : this.sureSimDevice?.imeiIccid;
                
      this.subLiveDataByIccid=this.webbingService.getLiveDataByIccidUpdates(<string>imeiIccid)
                              .pipe(
                                catchError((error) => {          
                                  return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
                                })
                              )
                              .subscribe({
                                next: data => {
                                  this.maybeGotLiveData(data);
                                 },
                                error: error => {
                                  let raiseError: boolean=true;
                                        
                                  if (error.message.includes(ErrorStrings.OriginalWebbingError)) {
                                    raiseError=!this.suppressOriginalWebbingError;
                                    console.log(error.message);
                                    this.maybeGotLiveData(undefined);
                                  }
                                        
                                  this.timelineFormHasBeenCancelled.emit();
                                        
                                  if (raiseError)
                                    this.exceptionsService.handleException(new Error(error));
                                }
                              });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getLocationData() {
    try {
      this.unsubscribeLocationDataByIccid();

      let imeiIccid=this.sureSimDevice?.imeiIccid==undefined ? -1 : this.sureSimDevice?.imeiIccid;
                
      this.subLocationDataByIccid=this.webbingService.getCurrentLocation(<string>imeiIccid)
                              .pipe(
                                catchError((error) => {          
                                  return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
                                })
                              )
                              .subscribe({
                                next: data => {
                                  this.maybeGotLocationData(data);
                                 },
                                error: error => {
                                  let raiseError: boolean=true;
                                        
                                  if (error.message.includes(ErrorStrings.OriginalWebbingError)) {
                                    raiseError=!this.suppressOriginalWebbingError;
                                    console.log(error.message);
                                    this.maybeGotLocationData(undefined);
                                  }
                                        
                                  this.timelineFormHasBeenCancelled.emit();
                                        
                                  if (raiseError)
                                    this.exceptionsService.handleException(new Error(error));
                                }
                              });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getLocationAwarenessText() {
    try {
      if (this.sureSimDevice != undefined && this.sureSimDevice.locationServices == false)
        return "Disabled"
      if (!this.locationDataLoaded)
        return "Loading..."
      if (this.sureSimLocationData == undefined || this.sureSimLocationData.CountryName == "null"|| this.sureSimLocationData.CountryName == null)
        return "No location data found"

      return "";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }
      
  public unsubscribeLiveDataByIccid() {
    try {
      if (this.subLiveDataByIccid) {
        this.subLiveDataByIccid.unsubscribe();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public unsubscribeLocationDataByIccid() {
    try {
      if (this.subLocationDataByIccid) {
        this.subLocationDataByIccid.unsubscribe();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
                  
  public maybeGotLiveData(webbingLiveData: WebbingLiveDataDTO | undefined) {
    try {
      this.sureSimLiveData=webbingLiveData;
      this.dataLoaded     =true;
      this.populateFormFields(this.timelineForm, false, false);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public maybeGotLocationData(webbingLocationData: EsimLocationDTO[] | undefined) {
    try {
      if (webbingLocationData != undefined && webbingLocationData.length > 0)
        this.sureSimLocationData=webbingLocationData[0];
      this.locationDataLoaded = true;
      this.populateFormFields(this.timelineForm, false, false);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Live Timeline

  public getLiveTimeline() {
    try {
      this.unsubscribeTimeline();

      if (this.sureSimUser==undefined || this.sureSimDevice==undefined)
        return;
      
      let imeiIccid=this.sureSimDevice?.imeiIccid==undefined ? -1 : this.sureSimDevice?.imeiIccid;
      let userId   =this.sureSimUser?.id         ==undefined ? -1 : this.sureSimUser?.id;
      
      this.subTimeline=this.widgetService.getLiveTimelineUpdates(userId, <string>imeiIccid)
                       .pipe(
                         catchError((error) => {          
                           return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
                         })
                       )
                       .subscribe({
                         next: data => {
                           this.liveTimeLineData=data;
                         },
                         error: error => {
                           this.timelineFormHasBeenCancelled.emit();
                           this.exceptionsService.handleException(new Error(error));
                         }
                       });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
      
  public unsubscribeTimeline() {
    try {
      if (this.subTimeline) {
        this.subTimeline.unsubscribe();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Country Details
      
  public getCountryDetails() {
    try {
      this.unsubscribeCountryDetails();

      if (this.sureSimUser==undefined || this.sureSimDevice==undefined)
        return;
      
      let imeiIccid=this.sureSimDevice?.imeiIccid==undefined ? -1 : this.sureSimDevice?.imeiIccid;
      let userId   =this.sureSimUser?.id         ==undefined ? -1 : this.sureSimUser?.id;
                
      this.subCountryDetails=this.widgetService.getCountryDetailsUpdates(userId, <string>imeiIccid, <number>(this.filterDate?.year ?? 1), <number>(this.filterDate?.month ?? 1), 1)
                             .pipe(
                               catchError((error) => {          
                                 return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
                               })
                             )
                             .subscribe({
                               next: data => {
                                 this.countryDetails=data;
                                },
                               error: error => {
                                 this.timelineFormHasBeenCancelled.emit();
                                 this.exceptionsService.handleException(new Error(error));
                               }
                             });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
      
  public unsubscribeCountryDetails() {
    try {
      if (this.subCountryDetails) {
        this.subCountryDetails.unsubscribe();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Country Usage Summary
      
  public getCountryUsageSummary() {
    try {
      this.unsubscribeCountryUsageSummary();

      if (this.sureSimUser==undefined || this.sureSimDevice==undefined)
        return;
      
      let imeiIccid=this.sureSimDevice?.imeiIccid==undefined ? -1 : this.sureSimDevice?.imeiIccid;
      let userId   =this.sureSimUser?.id         ==undefined ? -1 : this.sureSimUser?.id;
                
      this.subCountryUsageSummary=this.widgetService.getCountryUsageSummaryUpdates(userId, <string>imeiIccid, <number>(this.filterDate?.year ?? 1), <number>(this.filterDate?.month ?? 1), 1)
                                  .pipe(
                                    catchError((error) => {          
                                      return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
                                    })
                                  )
                                  .subscribe({
                                    next: data => {
                                      this.countryUsageSummary=data;

                                      // setTimeout(() => {
                                      //   this.updateCountryUsageSummaryContainerHeight();
                                      // });
                                    },
                                    error: error => {
                                      this.timelineFormHasBeenCancelled.emit();
                                      this.exceptionsService.handleException(new Error(error));
                                    }
                                  });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
      
  public unsubscribeApplicationUsageSummary() {
    try {
      if (this.subApplicationUsageSummary) {
        this.subApplicationUsageSummary.unsubscribe();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public unsubscribeCountryUsageSummary() {
    try {
      if (this.subCountryUsageSummary) {
        this.subCountryUsageSummary.unsubscribe();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private updateCountryUsageSummaryContainerHeight(): void {
    try {
      if (this.countryUsageContainer?.nativeElement) {
        this.containerHeightCountryUsage=this.countryUsageContainer.nativeElement.offsetHeight;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#endregion

  //#region Filter Area
                  
  public closeFilterArea() {
    try {
      this.showFilters=false;
      this.timelineForm.controls["filtersCheck"].setValue(this.showFilters);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
                  
  public showFiltersClick() {
    try {
      this.showFilters=!this.timelineForm.get("filtersCheck")?.value;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Charts
  
  //#region ICCID Usage for Current Day Chart
  
  private getIccidTodayUsage() {
    try {
      this.unsubscribeIccidTodayUsage();

      const iccid=this.sureSimDevice?.imeiIccid ?? "";

      // this.widgetService.getIccidTodayUsage(iccid)
      // .pipe(
      //   catchError(error =>
      //     throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
      //   )
      // )
      // .subscribe({
      //   next : data => this.updateTodayUsage(data),
      //   error: error => this.exceptionsService.handleException(new Error(this.exceptionsService.formatHttpError(error)))
      // });

      this.subIccidTodayUsage=this.widgetService.getIccidTodayUsageUpdates(iccid)
        .pipe(
          catchError(error =>
            throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          )
        )
        .subscribe({
          next : data => this.updateTodayUsage(data),
          error: error => this.exceptionsService.handleException(new Error(error))
        });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private updateTodayUsage(data: WidgetIccidTodayUsageDTO) {
    try {
      const size=data.DayUsage;

      if (this.todaysUsageGraphInMbOnly) {
        this.todayUsageTotalSymbol="MB";
        this.todayUsageTotal      =size/(1024*1024);

      } else if (size>=1024*1024*1024) {
        this.todayUsageTotalSymbol="GB";
        this.todayUsageTotal      =size/(1024*1024*1024);

      } else if (size>=1024*1024) {
        this.todayUsageTotalSymbol="MB";
        this.todayUsageTotal      =size/(1024*1024);

      } else if (size>=1024) {
        this.todayUsageTotalSymbol="KB";
        this.todayUsageTotal      =size/1024;

      } else {
        this.todayUsageTotalSymbol="B";
        this.todayUsageTotal      =size;
      }
  
      this.todayUsageTotalWithSymbol=Number(this.todayUsageTotal).toFixed(1) + this.todayUsageTotalSymbol;

      this.todaySessionsTotal=data.DaySessions;
      this.monthSessionsTotal=data.MonthSessions;

      this.populateFormFields(this.timelineForm, false, false);

      this.chartTodaysUsage?.addReading(data);
    } catch (e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
      
  public unsubscribeIccidTodayUsage() {
    try {
      if (this.subIccidTodayUsage) {
        this.subIccidTodayUsage.unsubscribe();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Application Usage

  private getApplicationTotalUsage() {
    try {
      this.unsubscribeApplicationUsageSummary();

      if (this.sureSimDevice==undefined)
        return;

      if (this.showApplicationChart) {
        this.subApplicationUsageSummary=
          this.widgetService.getApplicationTotalUsageUpdates(-1,
                                                        this.sureSimDevice?.imeiIccid ?? "",
                                                        -1,
                                                        <number>(this.filterDate?.year ?? 1),
                                                        <number>(this.filterDate?.month ?? 1),
                                                        1)
                            .pipe(
                              catchError((error) => {          
                                return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
                              })
                            )
                            .subscribe({
                              next: data => {
                                  data.sort((a, b) => Number(b.totalUsage) - Number(a.totalUsage));
                                  this.applicationData = data;
                                  
                                  //let applicationcolors: any=this.chartConfigService.resolveColours(this.chartConfigService.defaultColoursArray);
                                  let applicationcolors: any=this.chartConfigService.resolveColours(['--vz-suresim-blue']);

                                  this.applicationTotalUsageForCurrentMonthChart(applicationcolors);
                              },
                              error: error => {
                                this.exceptionsService.handleException(new Error(error));
                              }
                            });
        } else
        {
          this.subApplicationUsageSummary=
            this.widgetService.getApplicationTotalUsageUpdates(-1,
                                                               this.sureSimDevice?.imeiIccid ?? "",
                                                               -1,
                                                               <number>(this.filterDate?.year ?? 1),
                                                               <number>(this.filterDate?.month ?? 1),
                                                               1)
                              .pipe(
                                catchError((error) => {          
                                  return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
                                })
                              )
                              .subscribe({
                                next: data => {
                                  this.applicationUsageSummary=data
                                  let numberofItemsToShow = this.expandApplicationUsage ? 100 : 4;
                                  this.applicationUsageSummaryGrid = this.applicationUsageSummary!.slice(0, numberofItemsToShow); 
                                },
                                error: error => {
                                  this.timelineFormHasBeenCancelled.emit();
                                  this.exceptionsService.handleException(new Error(error));
                                }
                              });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public dateTimeFormatter = (value: any) => {
    let dateValue = new Date(Date.UTC(<number>(this.filterDate?.year ?? 1), <number>(this.filterDate?.month ?? 1) -1, value));
    let dateLabel = formatDate(dateValue, 'dd MMM');
    return dateLabel;
  };

  private CalculateApplicationMax() {
    try {
      this.maxValue = 0;
      if (this.applicationData != undefined && this.applicationData.length > 0) {
        let max = this.applicationData.reduce((prev, current) => {
          return (Number(prev.totalUsage) > Number(current.totalUsage)) ? prev : current;
        });
        this.maxValue = Number(max.totalUsage);

        if (this.maxValue < 1) {
          this.maxValue = 1.5;
        } else if (this.maxValue < 2) {
          this.maxValue = 2.5;
        } else {
          this.maxValue = Number(max.totalUsage) * 1.2;
          let i = Math.ceil(this.maxValue);
          let denominator = 0;
          if (i < 10) {
            denominator = 1;
          } else if (i < 50) {
            denominator = 5;
          } else if (i < 100) {
            denominator = 10;
          } else if (i < 500) {
            denominator = 50;
          } else if (i < 1000) {
            denominator = 100;
          } else if (i < 5000) {
            denominator = 500;
          } else if (i < 10000) {
            denominator = 1000;
          } else if (i < 50000) {
            denominator = 5000;
          } else {
            denominator = 10000;
          }

          while (i % denominator != 0) {
            i++;
          }
          this.maxValue = i;
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applicationTotalUsageForCurrentMonthChart(colors: any) {
    try {
      this.subApplications               = [];
      this.subApplictionSeries           = [];
      this.subApplicationUsageDayOfMonth = [];

      let numberofItemsToShow = this.expandApplicationUsage ? 100 : 5;
      let itemsToShow = this.applicationData!.slice(0, numberofItemsToShow); 
      this.subApplications               = Array.from(itemsToShow.map(daydata => daydata.application)); 
      
      let applicationsData = Array.from(itemsToShow.map(daydata => Number(daydata.totalUsage)));
      let newseries = {name:"Total Usage", type: "bar", data:applicationsData}
      this.subApplictionSeries.push(newseries);
      const applications = Array.from(this.subApplications);

      this.CalculateApplicationMax();

      if (this.applicationData != undefined && this.applicationData.length > 0 && this.containerHeightApplication > 0) {
        this.applicationChartUsage={
          chart: {
            id     : 'application-usage-chart',
            height : this.containerHeightApplication,
            toolbar: {
                show: false,
            },
            type: 'bar'
          },
          colors: colors,
          // plotOptions: {
          //   bar: {
          //     columnWidth: '90%',
          //     horizontal: true,
          //     dataLabels: {
          //       position: 'top'
          //     }
          //   },
          // },
          plotOptions: {
            bar: {
              barHeight              : Math.min(70, Math.max(1, applications.length)*11) + '%',
              borderRadius           : 4,
              borderRadiusApplication: 'end',
              dataLabels             : { position: 'top' },
              horizontal             : true
            },
          },
          dataLabels: {
            enabled: true,
            formatter: function(val: number) {
              return val + "MB";
            },
            offsetY: 2,
            offsetX: 25,
            style: {
              fontSize: '10px',
              fontWeight: 'lighter',
              colors: ['#878a99']
            }
          },
          series: this.subApplictionSeries,
          stroke: {
            curve: 'smooth',
            width: [0, 3]
          },
          title: {
            style: {
              fontWeight: 600,
            },
            text: undefined
          },
          tooltip: {
            x: {
              formatter: function(val: string) {
                return val;
              }
            },
            y: {
              formatter: function(val: number) {
                return val + "MB";
              }
            }
          },
          legend: {
            show           : false,
            fontSize       : '10px'
          },
          xaxis: {
            type      : 'string',
            categories: applications,
            max       : this.maxValue,
            labels: {
              show    : true,
              minWidth: 15,
              style: {
                fontSize: '12px'
              },
            },
            title: {
              style: {
                fontWeight: 600,
              },
              text: 'Total Usage (MB)'
            },
          },
          yaxis: [{
            labels: {
              show    : true,
              minWidth: 15,
            }
          }]
        };
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
    
  //#region SIM Activity for Current Month Heatmap
  
  private getSimActivity() {
    try {
      this.unsubscribeSimActivity();
      
      this.subSimActivity=this.widgetService.getSimActivityUpdates(this.sureSimDevice?.imeiIccid ?? "",
                                                                   <number>(this.filterDate?.year ?? 1),
                                                                   <number>(this.filterDate?.month ?? 1),
                                                                   <number>(this.filterDate?.day ?? 1))
                          .pipe(
                            catchError((error) => {
                              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
                            })
                          )
                          .subscribe({
                            next: data => {
                              this.activityHeatmap?.refreshHeatMap(data);

                              //console.log(JSON.stringify(data));
                            },
                            error: error => {
                              this.exceptionsService.handleException(new Error(error));
                            }
                          });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
      
  public unsubscribeSimActivity() {
    try {
      if (this.subSimActivity) {
        this.subSimActivity.unsubscribe();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public toggleHeatmapVisibility() {
    try {
      this.simActivityVisible=!this.simActivityVisible;

      // this.simActivityVisible ? this.getSimActivity()
      //                         : this.getIccidTodayUsage();
      //                           this.chartTodaysUsage?.getIccidTodayUsage(this.sureSimDevice?.imeiIccid);
      //                           this.chartUsagePerDay?.getIccidTotalUsage(this.sureSimDevice?.imeiIccid);
      //                         ;
      if (this.simActivityVisible) {
        this.getSimActivity();
      }
      else {
        this.getIccidTodayUsage();
        this.chartTodaysUsage?.resetReadings();
        this.chartUsagePerDay?.getIccidTotalUsage(this.sureSimDevice?.imeiIccid);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
  
  //#endregion

  //#region manageEsimModalForm

  public orderDataHasBeenSaved() {
    try {
      this.manageEsimFormIsOpen=false;

      this.getData();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public manageEsimFormHasBeenCancelled() {
    try {
      this.manageEsimFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Far Right Column Expansions

  // private setDefaultFarRightContainerHeights() {
  //   try {
  //     this.containerHeightApplication   = this.sizeDefaultApplication; 
  //     this.containerHeightCountryDetails= this.sizeDefaultCountryDay;
  //     this.containerHeightCountryUsage  = this.sizeDefaultCountrySummary;
  //     // this.setRightSideContainerHeights();
  //   }
  //   catch(e) {
  //     this.exceptionsService.handleException(<Error>e);
  //   }
  // }

  public refreshApplicationChart() {
    if (this.showApplicationChart
        && (this.expandApplicationUsage == true || (this.expandCountryDay == false && this.expandCountrySummary == false))
        && this.filterDeviceID != undefined
        && this.filterDeviceID > -1) {
      
      //let applicationcolors: any=this.chartConfigService.resolveColours(this.chartConfigService.defaultColoursArray);
      let applicationcolors: any=this.chartConfigService.resolveColours(['--vz-suresim-blue']);
      
      this.applicationTotalUsageForCurrentMonthChart(applicationcolors);
    } else if (this.applicationUsageSummary != undefined && this.applicationUsageSummary.length > 0){
      let numberofItemsToShow = this.expandApplicationUsage ? 100 : 4;
      this.applicationUsageSummaryGrid = this.applicationUsageSummary!.slice(0, numberofItemsToShow); 
    }
  }

  public applicationUsageExpandClick() {
    try {
      this.expandApplicationUsage=!this.expandApplicationUsage;
      
      this.setRightSideContainerHeights();
      this.refreshApplicationChart();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setRightSideContainerHeights() {
    try {
      if (this.expandApplicationUsage == true) {
        this.expandCountryDay              = false;
        this.expandCountrySummary          = false;
        this.containerHeightApplication    = this.sizeExpandedApplication;
        this.containerHeightCountryDetails = this.sizeColapsedCountryDay;
        this.containerHeightCountryUsage   = this.sizeColapsedCountrySummary;

      } else if (this.expandCountryDay == true) {
        this.applicationChartUsage         = undefined;
        this.expandApplicationUsage        = false;
        this.expandCountrySummary          = false;
        this.containerHeightApplication    = this.sizeColapsedApplication;
        this.containerHeightCountryDetails = this.sizeExpandedCountryDay;
        this.containerHeightCountryUsage   = this.sizeColapsedCountrySummary;
      
      } else if (this.expandCountrySummary == true) {
        this.applicationChartUsage         = undefined;
        this.expandApplicationUsage        = false;
        this.expandCountryDay              = false;
        this.containerHeightApplication    = this.sizeColapsedApplication;
        this.containerHeightCountryDetails = this.sizeColapsedCountryDay;
        this.containerHeightCountryUsage   = this.sizeExpandedCountrySummary;

      } else if (this.expandApplicationUsage == false && this.expandCountryDay == false && this.expandCountrySummary == false && this.filterDeviceID != undefined && this.filterDeviceID > -1) {
        this.containerHeightApplication    = this.sizeDefaultApplication;
        this.containerHeightCountryDetails = this.sizeDefaultCountryDay;
        this.containerHeightCountryUsage   = this.sizeDefaultCountrySummary;
      } else {
        this.containerHeightApplication    = this.sizeColapsedApplication;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public countryDayExpandClick() {
    try {
      this.expandCountryDay=!this.expandCountryDay;
      
      this.setRightSideContainerHeights();
      this.refreshApplicationChart();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public countrySummaryExpandClick() {
    try {
      this.expandCountrySummary=!this.expandCountrySummary;

      this.setRightSideContainerHeights();
      this.refreshApplicationChart();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public deviceDetailsExpandClick() {
    try {
      this.expandDeviceDetails=!this.expandDeviceDetails;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public orderDetailsExpandClick() {
    try {
      this.expandOrderDetails=!this.expandOrderDetails;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public simDetailsExpandClick() {
    try {
      this.expandSimDetails=!this.expandSimDetails;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
  
  //#region Features
  
  public enableFeatures() {
    try {
      if (!this.enableFeaturesHasExecuted) {
        this.enableFeaturesHasExecuted=true;
        
        this.enableFeatureApplicationGraph();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public enableFeatureApplicationGraph() {
    try {
      if (!this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormTimelineApplicationSummaryShowContainer, false)) {
        this.featureEnabledApplicationGraph=false;

      } else {
        this.licencesCompanyAllocatedService.companyHasLicenceFeatureByGuid(this.curUser.companyId, AccessGuids.ChargeableFeatureApplicationSummaries)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.featureEnabledApplicationGraph=data.result;
            this.setRightSideContainerHeights();
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
